// Words before the parenthesis of a cyclone severity text. Wind numbers and units are never shown.
const WORDS_RE = /^[\p{L}][\p{L}\s-]{1,39}$/u;
const UNIT_RE = /\d+(?:[.,]\d+)?\s*(?:mph|km\/h|kmh|kph|kts?|knots?|m\/s)?|\b(?:mph|km\/h|kmh|kph|kts?|knots?)\b/gi;

const sentence = (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();   // 'Tropical storm'

// 'Hurricane/Typhoon' is one name for the same storm: the Americas and the east Pacific say Hurricane
// (west longitudes), the west Pacific says Typhoon. Without a longitude it reads Hurricane.
const pickAlternative = (alts, lng) => {
  const has = (re) => alts.find((a) => re.test(a));
  const hu = has(/^hurricane$/i);
  const ty = has(/^typhoon$/i);
  if (hu && ty) return Number.isFinite(lng) && lng > 0 ? ty : hu;
  return alts[0];
};

export function stormClassWords(text, { lng } = {}) {
  const s = String(text ?? '').trim();
  if (!s) return null;
  const rawHead = s.split('(')[0].replace(/\s+/g, ' ').trim();
  if (!rawHead || /^magnitude\b/i.test(rawHead)) return null;
  const head = rawHead.replace(UNIT_RE, ' ').replace(/[<>=≥≤~+]/g, ' ').replace(/\s+/g, ' ').trim();
  const alts = head.split('/').map((a) => a.trim()).filter(Boolean);
  if (!alts.length || alts.some((a) => !WORDS_RE.test(a))) return null;
  return sentence(pickAlternative(alts, Number(lng)));
}

// i18n key slug: 'tropical_storm' | 'tropical_depression' | 'hurricane' | 'typhoon' | ... | null
export const keyForWords = (w) => (w ? w.toLowerCase().replace(/[^a-z]+/g, '_').replace(/^_|_$/g, '') : null);

// Class of the track at the storm's current position (HU/TS/TD from the parsed geometry): the observed
// segment that ends at the current position, else the first forecast segment.
const TRACK_WORDS = { HU: 'Hurricane', TS: 'Tropical storm', TD: 'Tropical depression' };
export function trackClassWords(parsed, { lng } = {}) {
  const segments = parsed?.track?.segments;
  if (!Array.isArray(segments) || !segments.length) return null;
  const past = segments.filter((x) => x.phase === 'past');
  const current = past.length ? past[past.length - 1] : segments.find((x) => x.phase === 'forecast');
  const words = TRACK_WORDS[current?.cls];
  if (!words) return null;
  return words === 'Hurricane' && Number.isFinite(Number(lng)) && Number(lng) > 0 ? 'Typhoon' : words;
}

// Parsed text first, then the track class; null means the Class row is hidden.
export const resolveStormClass = ({ text, parsed, lng } = {}) =>
  stormClassWords(text, { lng }) || trackClassWords(parsed, { lng });
